import { auth0Client } from "@src/auth/auth0-provider-with-navigate";
import { PARAMS, ROUTES } from "@src/common/constants";
import { redirect } from "react-router-dom";
import { runDemoFlow } from "./demo-loader";

export async function rootLoader({ request }: { request: Request }) {
	const url = new URL(request.url);
	const demoParam = url.searchParams.get(PARAMS.demo);

	if (!demoParam) {
		return redirect(ROUTES.ask);
	}

	let isAuthenticated = false;
	try {
		isAuthenticated = await auth0Client.isAuthenticated();
	} catch {
		isAuthenticated = false;
	}

	if (isAuthenticated) {
		return redirect(ROUTES.ask);
	}

	const redirectUrl = await runDemoFlow(url);
	if (!redirectUrl) {
		console.error("Demo flow failed to resolve redirect URL", {
			pathname: url.pathname,
			search: url.search,
		});
		return null;
	}

	// Full page navigation is intentional: the whiteboard URL contains a shareKey
	// that must be picked up by auth signals on a fresh load. SPA navigation via
	// redirect() keeps the unauthenticated layout mounted and triggers the auth guard.
	window.location.assign(redirectUrl);
	return null;
}
